import type { LocaleCode } from '@/i18n/locales'
import type { PrivacyPageLocaleContent } from '../types'
import { privacyPageEn } from './en'
import { privacyPageEs } from './es'

const privacyByLocale: Partial<Record<LocaleCode, PrivacyPageLocaleContent>> = {
  en: privacyPageEn,
  es: privacyPageEs,
}

export function getPrivacyPageContent(locale: LocaleCode): PrivacyPageLocaleContent {
  return privacyByLocale[locale] ?? privacyPageEn
}
